import { withRouter } from 'react-router-dom';
import { Box, Typography, Grid } from '@material-ui/core';
import NotificationsIcon from '@material-ui/icons/Notifications';
import InfoIcon from '@material-ui/icons/Info';
import styles from './Notification.style';
import { useTranslation } from 'react-i18next';
import { MobileRegularPage } from '../../../components';
import { AppButton } from "../components/InputComponents";
import { Link } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { useState, useEffect } from 'react';


const cookies = new Cookies();

const Notification = (props) => {
    const classes = styles();
    const [notifications, setNotifications] = useState([]);

    useEffect(() => {
        const getNotifications = async () => {
            try {
                let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_NOTIFICATION}`, {
                    headers: {
                        'X-ACCESS-TOKEN': cookies.get('token')
                    }
                });
                if (!response) return;
                let notifications = await response.json();
                setNotifications(notifications);
            } catch (error) {
                console.log(error);
            }
        };

        getNotifications();
    }, []);

    const { t } = useTranslation();
    return (
        <MobileRegularPage>

            <Box className={classes.title}>
                <Box>
                    <NotificationsIcon style={{ fontSize: '90' }} />
                </Box>
                <Typography variant="h3">{t('module.provider.notification.title')}</Typography>
            </Box>
            {(notifications.length == 0) ?
                <Typography>{t('module.provider.notification.message.noNotifications')}</Typography> :
                notifications.map((method, i) => {
                    return (
                        <Grid container spacing={1} className={classes.notifications} key={i}>
                            <InfoIcon></InfoIcon>
                            <Typography>{method}</Typography>
                        </Grid>
                    )
                })
            }
            < AppButton
                style={{ marginTop: "20px" }}
                variant="contained"
                color="secondary"
                fullWidth
                size="large"
                component={Link}
                to="/app/dashboard"
                onClick={props.scrollToTop}
            >
                Back To Dashboard
            </AppButton>

        </MobileRegularPage >

    );
}

export default withRouter(Notification);